// #tag: AUTHENTICATION API CLIENT
// #purpose: Dispatches authentication requests (email login, registration, Google OAuth, phone sign-in, session restore, logout).
import { apiGet, apiPost } from './client';
import type { AuthUser } from '../types';

const TOKEN_KEY = 'token';

interface AuthResponse {
  token: string;
  user: AuthUser;
}

export async function loginRequest(email: string, password: string): Promise<AuthUser> {
  const res = await apiPost<AuthResponse>('/auth/login', { email, password });
  localStorage.setItem(TOKEN_KEY, res.token);
  return res.user;
}

export async function registerRequest(name: string, email: string, password: string): Promise<AuthUser> {
  const res = await apiPost<AuthResponse>('/auth/signup', { name, email, password });
  localStorage.setItem(TOKEN_KEY, res.token);
  return res.user;
}

// #tag: GOOGLE OAUTH API REQUEST
// #purpose: Sends Google Firebase ID token to the server for exchange and session creation.
export async function googleSignInRequest(idToken: string): Promise<AuthUser> {
  const res = await apiPost<AuthResponse>('/auth/google', { idToken });
  localStorage.setItem(TOKEN_KEY, res.token);
  return res.user;
}

export async function phoneSignInRequest(idToken: string, name?: string): Promise<AuthUser> {
  const res = await apiPost<AuthResponse>('/auth/phone', { idToken, name });
  localStorage.setItem(TOKEN_KEY, res.token);
  return res.user;
}

// #tag: CURRENT USER PROFILE FETCHER
// #purpose: Retrieves the active user session payload from /auth/me.
export async function fetchCurrentUser(): Promise<AuthUser> {
  return apiGet<AuthUser>('/auth/me');
}

export async function logoutRequest(): Promise<void> {
  try {
    await apiPost<{ message: string }>('/auth/logout');
  } catch {
    /* cookie clear is best-effort */
  }
}

export function hasToken(): boolean {
  return Boolean(localStorage.getItem(TOKEN_KEY));
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('wfx-results-user');
  localStorage.removeItem('user');
}
